import Loader from 'examples/Loader'
import { useAppServices } from 'hook/services'
import ssoHandler from 'layouts/Pages/ssoHandler'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import TabsHeader from './components/TabsHeader'

const index = () => {
  const { app_id, id } = useParams()
  const params = useParams()
  console.log("params", params)
  console.log("app_id", app_id)
  const { SSO, checkSSO } = ssoHandler()
  const [ssodata, setssodata] = useState({})
  const [appData, setAppData] = useState({})
  const [snapshotData, setSnapshotData] = useState({})
  const [loader, setloader] = useState(true)
  const AppService = useAppServices()
  const iframeStyles = {
    width: '100%',
    height: 'calc(100vh - 70px)',
    border: 'none',
  }
  const AppsData = async () => {
    const { response } = await AppService.snapshot_onboarding.filter({
      query: `app_id=${app_id}`,
    })
    console.log(response, 'AppsData')
    if (response) {
      setAppData(response.data)
      setSnapshotData(response.snapshotData)
      checkSSO(response.data)
    }
  }
  useEffect(() => {
    AppsData()
  }, [])
  useEffect(() => {
    if (SSO != '' && SSO != undefined) {
      var data = JSON.parse(SSO)
      setssodata(data)
      setloader(false)
    }
    console.log(SSO, 'SSOSSO')
  }, [SSO])

  return (
    <>
      {/* {loader ? (
        <Loader />
      ) : ( */}
      <>
        <div>
          <TabsHeader
            pages={ssodata?.activeLocation ? appData?.location_pages : appData?.agency_pages}
            appData={appData}
            snapshotData={snapshotData}
            ssodata={ssodata}
            app_id={app_id}
          />
        </div>
      </>
      {/* )} */}
    </>
  )
}

export default index
